<template>
  <div
    v-if="hasImage"
    class="main-image"
  >
    <div class="container">
      <div
        :style="mainImageStyle"
        class="main-image__wrapper"
      />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import isBlank from 'is-blank'

export default {
  computed: {
    ...mapState({
      content: state => state.content.content,
    }),
    imageAttachments () {
      if (this.content && !isBlank(this.content.attachments)) {
        return this.content.attachments.filter(d => d.contentType.startsWith('image/'))
      }
    },
    articleImage () {
      return this.imageAttachments &&
             this.imageAttachments[0] &&
             this.imageAttachments[0].url
    },
    hasImage () {
      return !isBlank(this.articleImage)
    },
    mainImageStyle () {
      return {
        'backgroundImage': `url('${this.articleImage}')`
      }
    },
  }
}
</script>

<style lang="sass">
@import '~styles/imports'

.main-image
  &__wrapper
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    height: 400px;

    +respond-max($sm)
      height: 250px;
</style>



// WEBPACK FOOTER //
// src/components/contents/content/ContentMainImage.vue